import logo from './logo.svg';
import './App.css';
import HeroSection from './Components/HeroSection';

function App() {
  return (
    <div>
      <HeroSection/>
    </div>
  );
}

export default App;
